import { render, staticRenderFns } from "./FleetDetailsActivity.vue?vue&type=template&id=19b96a06&scoped=true&"
import script from "./FleetDetailsActivity.vue?vue&type=script&lang=js&"
export * from "./FleetDetailsActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b96a06",
  null
  
)

export default component.exports